export enum CallPeriod {
  ALL = "all",
  LAST_7_DAYS = "7d",
  LAST_30_DAYS = "30d",
  LAST_90_DAYS = "90d",
  LAST_12_MONTHS = "12m",
  THIS_YEAR = "year",
  CUSTOM = "custom",
}

export enum CallPeriodField {
  FROM = "from",
  TO = "to",
}

export type CallPeriodRange = {
  from?: string;
  to?: string;
};
